module.exports = __webpack_public_path__ + "static/media/logo_white.a9e91fc8.svg";